"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isMatch = function isMatch(sectionId, fieldId, message) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    var testValue = form.$("".concat(sectionId, "__").concat(fieldId)).value;

    if (!testValue) {
      return [true, ''];
    }

    var isValid = _validator.default.equals(field.value, testValue);

    return [isValid, message || 'Provided value does not match.'];
  };
};

var _default = isMatch;
exports.default = _default;
//# sourceMappingURL=isMatch.js.map